import React, { Fragment, useEffect, useState, useMemo, useCallback, useRef } from "react";
import {
  Table, Button, Card, CardBody, Col, Container, CardHeader, Nav, NavItem, NavLink, Row, Modal, ModalHeader, Form, ModalBody, Label, Input, FormFeedback, Spinner, UncontrolledButtonDropdown, UncontrolledDropdown, DropdownItem, DropdownMenu, DropdownToggle, ButtonGroup
} from "reactstrap";
import moment from "moment";
import "moment-timezone";
import { Link } from "react-router-dom";
import classnames from "classnames";
import BreadCrumb from "../../../Components/Common/BreadCrumb";
import DeleteModal from "../../../Components/Common/DeleteModal";
import ApproveModal from "../../../Components/Common/ApproveModal";
import { isEmpty, clone } from "lodash";
import { useTable, useGlobalFilter, useAsyncDebounce, useSortBy, useFilters, useExpanded, usePagination, useRowSelect } from "react-table";
import Flatpickr from "react-flatpickr";
import Select from "react-select";
// Formik
import * as Yup from "yup";
import { useFormik } from "formik";

//redux
import { useSelector, useDispatch } from "react-redux";

//Import actions
import { getEmployee, resetEmployeeState } from "../../../store/employee/action";
import {
  resetEmployeeAssessmentDetailState,
  getEmployeeAssessmentDetail as onGetEmployeeAssessmentDetails,
  addNewEmployeeAssessmentDetail as onAddNewEmployeeAssessmentDetail,
  updateEmployeeAssessmentDetail as onUpdateEmployeeAssessmentDetail,
  deleteEmployeeAssessmentDetail as onDeleteEmployeeAssessmentDetail,
  getEmployeeAssessmentDetailLoading,
} from "../../../store/employeeAssessmentDetail/action";
import {
  getEmployeeAssessment as onGetEmployeeAssessments,
  addNewEmployeeAssessment as onAddNewEmployeeAssessment,
  updateEmployeeAssessment as onUpdateEmployeeAssessment,
  deleteEmployeeAssessment as onDeleteEmployeeAssessment,
  getEmployeeAssessmentLoading,
  resetEmployeeAssessmentState,
} from "../../../store/employeeAssessment/action";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const EmployeeAssessment = () => {
  const [modal, setModal] = useState(false);
  const [activeTab, setActiveTab] = useState("1");
  const dispatch = useDispatch();

  const {
    employeeAssessments,
    isEmployeeAssessmentCreated,
    isEmployeeAssessmentSuccess,
    loading,
    error,
    employeeAssessmentDetails,
    employeeAssessmentDetailLoading,
    isEmployeeAssessmentDetailCreated,
    isEmployeeAssessmentDetailSuccess,
    employees,
    employeeLoading
  } = useSelector((state) => ({
    employeeAssessments: state.EmployeeAssessment.employeeAssessments,
    isEmployeeAssessmentCreated: state.EmployeeAssessment.isEmployeeAssessmentCreated,
    isEmployeeAssessmentSuccess: state.EmployeeAssessment.isEmployeeAssessmentSuccess,
    loading: state.EmployeeAssessment.loading,
    error: state.EmployeeAssessment.error,
    employeeAssessmentDetails: state.EmployeeAssessmentDetail.employeeAssessmentDetails,
    employeeAssessmentDetailLoading: state.EmployeeAssessmentDetail.loading,
    isEmployeeAssessmentDetailCreated: state.EmployeeAssessmentDetail.isEmployeeAssessmentDetailCreated,
    isEmployeeAssessmentDetailSuccess: state.EmployeeAssessmentDetail.isEmployeeAssessmentDetailSuccess,
    employees: state.Employee.employees,
    employeeLoading: state.Employee.loading,
  }));

  const [isSearch, setIsSearch] = useState(false);
  const [employeeAssessmentList, setEmployeeAssessmentList] = useState([]);
  const [employeeAssessment, setEmployeeAssessment] = useState([]);
  const [assessmentDetailAddedId, setAssessmentDetailAddedId] = useState(0);
  const [info, setInfo] = useState([]);
  const [statusActive, setStatusActive] = useState([]);
  const [employeeAssessmentDetail, setEmployeeAssessmentDetail] = useState([]);
  const [approveModal, setApproveModal] = useState(false);

  const [isLoading, setIsLoading] = useState(false);
  const [isEdit, setIsEdit] = useState(false);
  const [isEditDetail, setIsEditDetail] = useState(false);
  const [deleteModal, setDeleteModal] = useState(false);
  const [deleteModalMulti, setDeleteModalMulti] = useState(false);
  const [employeeList, setEmployeeList] = useState([]);
  const [employee, setEmployee] = useState(null);
  const [isApprover, setIsApprover] = useState(false);
  const [isAdmin, setIsAdmin] = useState(false);
  const ref = useRef(null);


  const defaultdate = () => {
    return moment(new Date())

      .format("YYYY/MM/DD HH:mm:ss")
      .toString();
  };

  const onClickDelete = (employeeAssessment) => {
    setEmployeeAssessment(employeeAssessment);
    setDeleteModal(true);
  };

  const handleDeleteEmployeeAssessment = () => {
    if (employeeAssessment) {
      dispatch(onDeleteEmployeeAssessment(employeeAssessment));
      setDeleteModal(false);
    }
  };

  const onClickApprove = (employee) => {
    setEmployeeAssessment(employee);
    setApproveModal(true);
  };

  useEffect(() => {
    setIsLoading(loading);
  }, [loading]);

  const toggleTab = (tab, type) => {
    if (activeTab !== tab) {
      setActiveTab(tab);
      let filteredEmployeeAssessments = employeeAssessments;
      if (type !== "all") {
        filteredEmployeeAssessments = employeeAssessments.filter(
          (employeeAssessment) => employeeAssessment.kpiea_status.name === type
        );
      }
      setEmployeeAssessmentList(filteredEmployeeAssessments);
    }
  };

  useEffect(() => {
    if (!isSearch) {
      dispatch(onGetEmployeeAssessments());
      setIsSearch(true);
    }
  }, [dispatch, employeeAssessments, isSearch]);


  useEffect(() => {
    if (!employee) {
      const emp = JSON.parse(localStorage.getItem("authUser"));
      setEmployee(emp);
      if (emp.data && emp.data.employee_user && emp.data.employee_user.user_role) {
        emp.data.employee_user.user_role.forEach(element => {
          if (element.method === "approveEmployeeAssessment") {
            setIsApprover(true);
            dispatch(resetEmployeeState());
            if (isAdmin) {
              dispatch(getEmployee({ type: "referral", status: 2 }));
            }
            else {
              dispatch(getEmployee({ positionId: emp.data.positionId, type: "referral", status: 2 }));
            }
          }
        });
      }
    }
  }, [employee, isAdmin, dispatch]);

  useEffect(() => {
    if (!isEmpty(employeeAssessments)) {
      setIsEdit(false);
      setEmployeeAssessmentList(employeeAssessments);
      let current = 0;
      if (assessmentDetailAddedId !== 0) {
        employeeAssessments.forEach((obj, i) => {
          if (obj.id === assessmentDetailAddedId) current = i;
        });
      }
      setInfo(employeeAssessments[current]);
    }
  }, [employeeAssessments, assessmentDetailAddedId]);

  useEffect(() => {
    if (isEmployeeAssessmentDetailCreated) {
      dispatch(resetEmployeeAssessmentDetailState());
      dispatch(resetEmployeeAssessmentState());
      dispatch(onGetEmployeeAssessments());
    }
  }, [dispatch, isEmployeeAssessmentDetailCreated]);

  useEffect(() => {
    if (!isEmpty(employees)) {
      var data = [];
      var opt = [];
      employees.forEach((item, key) => {
        const name = item.name;
        const id = item.id;
        const companyId = item.companyId;
        const positionId = item.positionId
        var obj = { label: name, value: id, companyId: companyId, positionId: positionId };
        opt.push(obj);
      })
      var option = { options: opt }
      data.push(option);
      setEmployeeList(data);
    }
  }, [employees]);

  const [filterDate, setFilterDate] = useState(null);

  const handleValidDate = (date) => {
    return moment(new Date(date), "YYYY/MM/DD").format("MMM D, YYYY");
  };

  const toggle = useCallback(() => {
    if (modal) {
      setModal(false);
      setEmployeeAssessment(null);
      dispatch(resetEmployeeState());
    } else {
      setModal(true);
    }
  }, [modal, dispatch]);

  const handleEmployeeAssessmentClick = useCallback((arg) => {
    const data = arg;
    setEmployeeAssessment({
      id: data.id,
      assessmentat: data.assessmentat,
      percentage: data.percentage,
      company: { label: data.kpiea_company.name, value: data.kpiea_company.id },
      employee: { label: data.kpiea_employee.name, value: data.kpiea_employee.id, companyId: data.kpiea_employee.companyId, positionId: data.kpiea_position.id },
      //employee: !!isApprover ? { label: employee.data.name, value: employee.data.id, companyId: employee.data.companyId, positionId: employee.data.positionId } :
    });

    setIsEdit(true);
    toggle();
  }, [toggle]);

  const columns = useMemo(() => [{
    Header: " ",
    maxWidth: 100,
    filterable: false,
    Cell: (cellProps) => {
      let data = cellProps.row.original;
      return (
        <div className="hstack gap-2 mt-4 mt-sm-0">
          {cellProps.row.original.statusId === 1 || cellProps.row.original.statusId === 3 ? (
            <button className="btn-label btn btn-sm btn-soft-success fs-12 me-0" onClick={() => {
              onClickApprove(data);
            }}>
              <i className="ri-checkbox-circle-line label-icon align-middle fs-16"></i>Approve</button>
          ) : (
            <button className="btn-label btn btn-sm btn-soft-warning fs-12 me-0" onClick={() => {
              onClickDelete(data);
            }}>
              <i className="ri-checkbox-circle-line label-icon align-middle fs-16 me-1"></i>Not Approve</button>)}
          <Link to="#" className="btn-icon btn btn-sm btn-light" onClick={() => {
            setInfo(data);
            ref.current?.scrollIntoView({ behavior: 'smooth' });
          }}><i className="ri-eye-line fs-15"></i>
          </Link>
          <Link to="#" className="btn-icon btn btn-sm btn-light edit-item-btn" onClick={() => {
            handleEmployeeAssessmentClick(cellProps.row.original);
          }}><i className="ri-edit-2-line fs-15"></i>
          </Link>
        </div>
      );
    },
  },
  {
    Header: "Employee",
    accessor: "kpiea_employee.name",
    filterable: true,
  },
  {
    Header: "Period",
    accessor: "startat",
    filterable: true,
    Cell: (data) => (<>{handleValidDate(data.row.original.startat)}</>),
  },
  {
    Header: "By Employee",
    filterable: true,
    Cell: (data) => (<>{data.row.original.total_realization}</>),
  },
  {
    Header: "By Assessor",
    filterable: true,
    Cell: (data) => (<>{data.row.original.total_asessor}</>),
  },
  {
    Header: "Status",
    accessor: "kpiea_status.name",
    filterable: true,
    Cell: (cell) => {
      switch (cell.value) {
        case "DRAFT":
          return (
            <span className="badge text-uppercase badge-soft-warning">{cell.value}</span>
          );
        case "ACTIVE":
          return (
            <span className="badge text-uppercase badge-soft-info">{cell.value}</span>
          );
        case "INACTIVE":
          return (
            <span className="badge text-uppercase badge-soft-danger">{cell.value}</span>
          );
        default:
          return (
            <span className="badge text-uppercase badge-soft-warning">{cell.value}</span>
          );
      }
    },
  }], [handleEmployeeAssessmentClick]);

  const {
    getTableProps, rows,
    getTableBodyProps,
    headerGroups,
    page,
    prepareRow,
    canPreviousPage,
    canNextPage,
    pageOptions,
    gotoPage,
    nextPage,
    previousPage,
    setPageSize,
    preGlobalFilteredRows,
    setGlobalFilter,
    state: { pageIndex, pageSize },
  } = useTable(
    {
      columns: columns,
      data: employeeAssessmentList,
      defaultColumn: { Filter: null },
      initialState: {
        pageIndex: 0,
        pageSize: 8,
        selectedRowIds: 0,

      },
    },
    useGlobalFilter,
    useFilters,
    useSortBy,
    useExpanded,
    usePagination,
    useRowSelect
  );

  const generateSortingIndicator = (column) => {
    return column.isSorted ? (column.isSortedDesc ? " " : "") : "";
  };

  const generateFilterable = (column) => {
    return column.filterable
      ? column.isSorted
        ? column.isSortedDesc
          ? " sorting_desc"
          : " sorting_asc"
        : " sort"
      : "";
  };

  const onChangeInSelect = (event) => {
    setPageSize(Number(event.target.value));
  };

  const onChangeInInput = (event) => {
    const page = event.target.value ? Number(event.target.value) - 1 : 0;
    gotoPage(page);
  };

  const count = preGlobalFilteredRows.length;
  const [searchValue, setSearchValue] = useState([]);
  const onChange = useAsyncDebounce((value) => { setGlobalFilter(value || undefined); }, 600);

  const handleApproveAssessment = () => {
    if (employeeAssessment) {
      employeeAssessment.setApprove = true;
      dispatch(onUpdateEmployeeAssessment(employeeAssessment));
      setApproveModal(false);
    }
  };

  const validation = useFormik({
    enableReinitialize: true,
    initialValues: {
      assessmentat: (employeeAssessment && employeeAssessment.assessmentat),
      employee: (employeeAssessment && employeeAssessment.employee),
    },
    validationSchema: Yup.object({
      assessmentat: Yup.string().required("Please Enter Assessment Date").nullable(true),
      employee: Yup.object().required("Please Enter Employee").nullable(true),
    }),
    onSubmit: (values) => {
      let datearr = values.assessmentat.split(" to ");
      let startat = datearr[0] && datearr[0];
      let endat = datearr[1] ? datearr[1] : datearr[0] && datearr[0];

      dispatch(getEmployeeAssessmentLoading());
      if (isEdit) {
        const updateEmployeeAssessment = {
          id: employeeAssessment ? employeeAssessment.id : 0,
          startat: startat,
          endat: endat,
          employeeId: values.employee.value,
          positionId: values.employee.positionId,
          companyId: values.employee.companyId,
          statusId: 2,
        };
        dispatch(onUpdateEmployeeAssessment(updateEmployeeAssessment));
        validation.resetForm();
      } else {
        const newEmployeeAssessment = {
          startat: startat,
          endat: endat,
          employeeId: values.employee.value,
          positionId: values.employee.positionId,
          companyId: values.employee.companyId,
          statusId: 2,
        };
        dispatch(onAddNewEmployeeAssessment(newEmployeeAssessment));
        validation.resetForm();
      }
      toggle();
    },
  });

  // Delete Multiple
  const deleteMultiple = () => {
    const ele = document.querySelectorAll(".dataCheckbox:checked");
    const checkall = document.getElementById("checkBoxAll");
    ele.forEach((element) => {
      dispatch(onDeleteEmployeeAssessmentDetail(element.value));
    });
    checkall.checked = false;
  };

  function handleFilter() {
    let startat = "";
    let endat = "";
    let datearr = filterDate?.split(" to ");
    if (datearr) {
      startat = datearr[0];
      endat = datearr[1] ? datearr[1] : datearr[0];
    }
    var status = statusActive.value ? statusActive.value : "";
    const param = {
      title: searchValue,
      startat: startat,
      endat: endat,
      status: status,
    };
    dispatch(onGetEmployeeAssessments(param));
  }

  document.title = "Assessment Guideline | Enterprise Resources Planning";

  return (
    <div className="page-content">
      <ApproveModal
        data={employeeAssessment && employeeAssessment.kpiea_employee ? employeeAssessment.kpiea_employee.name : ""}
        show={approveModal}
        onApproveClick={handleApproveAssessment}
        onCloseClick={() => setApproveModal(false)} />
      <DeleteModal show={deleteModal} onDeleteClick={handleDeleteEmployeeAssessment} onCloseClick={() => setDeleteModal(false)} />
      <DeleteModal show={deleteModalMulti} onDeleteClick={() => { deleteMultiple(); setDeleteModalMulti(false); }} onCloseClick={() => setDeleteModalMulti(false)} />
      <Container fluid>
        <BreadCrumb title="Job Performance" pageTitle="Human Resources" />
        <Row>
          <Col xxl={7}>
            <Card>
              <CardHeader className="card-header border-0">
                <div className="d-flex align-items-center">
                  <h5 className="card-title mb-0 flex-grow-1">
                    Job Performance History&nbsp;
                    {isLoading ? (
                      <>
                        <Spinner color="primary" type="grow" size={"sm"}>Loading...</Spinner>
                        &nbsp;
                        <Spinner color="success" type="grow" size={"sm"}>Loading...</Spinner>
                        &nbsp;
                      </>
                    ) : ("")}
                  </h5>
                </div>
              </CardHeader>
              <CardBody className="pt-0">
                <div>
                  <Nav className="nav-tabs nav-tabs-custom nav-success" role="tablist">
                    <NavItem>
                      <NavLink
                        className={classnames({ active: activeTab === "1" }, "fw-semibold")} onClick={() => { toggleTab("1", "all"); }}
                        href="#" >
                        <i className=" ri-star-line me-1 align-bottom fs-14"></i> All
                      </NavLink>
                    </NavItem>
                    <NavItem>
                      <NavLink className={classnames({ active: activeTab === "2" }, "fw-semibold")} onClick={() => { toggleTab("2", "DRAFT"); }} href="#">
                        <i className="ri-information-line me-1 align-bottom fs-14"></i> DRAFT
                      </NavLink>
                    </NavItem>
                    <NavItem>
                      <NavLink className={classnames({ active: activeTab === "3" }, "fw-semibold")} onClick={() => { toggleTab("3", "ACTIVE"); }} href="#">
                        <i className="ri-checkbox-circle-line me-1 align-bottom fs-14"></i> ACTIVE</NavLink>
                    </NavItem>
                    <NavItem>
                      <NavLink className={classnames({ active: activeTab === "4" }, "fw-semibold")} onClick={() => { toggleTab("4", "INACTIVE"); }} href="#">
                        <i className="ri-indeterminate-circle-line me-1 align-bottom fs-14"></i> INACTIVE
                      </NavLink>
                    </NavItem>
                  </Nav>
                  <Row className="mb-3">
                    <CardBody className="border border-top-0 border-end-0 border-start-0">
                      <form>
                        <Row>
                          <Col sm={1} className="col-xxl-3">
                            <div className="me-2 mb-2 col-12">
                              <select className="form-select"
                                value={pageSize}
                                onChange={onChangeInSelect}>
                                {[10, 25, 50, 100, 150, 250, 500, 1000, 2500, 5000].map((pageSize) => (
                                  <option key={pageSize} value={pageSize}>
                                    {pageSize}
                                  </option>
                                ))}
                              </select>
                            </div>
                          </Col>
                          <Col sm={5}>
                            <div className="search-box me-2 mb-2 d-inline-block col-12">
                              <input
                                onChange={(e) => {
                                  setSearchValue(e.target.value);
                                  onChange(e.target.value);
                                  gotoPage(0);
                                }}
                                id="search-bar-0"
                                type="text"
                                className="form-control search"
                                placeholder={`${count} Search...`}
                                value={searchValue ?? ""} />
                              <i className="bx bx-search-alt search-icon"></i>
                            </div>
                          </Col>
                          <Col className="col-xxl-4">
                            <div>
                              <button
                                type="button"
                                className="btn btn-light w-100"
                                onClick={() => { handleFilter(); }}>
                                <i className="ri-search-line me-1 align-bottom fs-14"></i>
                              </button>
                            </div>
                          </Col>
                        </Row>
                      </form>
                    </CardBody>
                  </Row>
                  <div className="table-responsive table-card mb-1">
                    <Table
                      hover
                      {...getTableProps()}
                      className="align-middle table-nowrap">
                      <thead className="table-light">
                        {headerGroups.map((headerGroup, index) => (
                          <tr
                            {...headerGroup.getHeaderGroupProps()} className={""} key={index}>
                            {headerGroup.headers.map((column, index) => (
                              <th
                                {...column.getSortByToggleProps()} className={"" + generateFilterable(column)} key={index}>
                                {column.render("Header")}
                                {generateSortingIndicator(column)}
                                {/* <Filter column={column} /> */}
                              </th>
                            ))}
                          </tr>
                        ))}
                      </thead>

                      <tbody {...getTableBodyProps()}>
                        {page.map((row) => {
                          prepareRow(row);
                          return (
                            <Fragment key={row.getRowProps().key}>
                              <tr>
                                {row.cells.map((cell, index) => {
                                  return (
                                    <td {...cell.getCellProps()} key={index}>
                                      {cell.render("Cell")}
                                    </td>
                                  );
                                })}
                              </tr>
                            </Fragment>
                          );
                        })}
                      </tbody>
                    </Table>
                  </div>

                  <Row className="justify-content-md-end justify-content-center align-items-center p-2">
                    <Col className="col-md-auto d-none d-md-block">{rows.length} Data</Col>
                    <Col className="col-md-auto">
                      <div className="d-flex gap-1">
                        <Button
                          color="light"
                          onClick={previousPage}
                          disabled={!canPreviousPage}>{"<"}</Button>
                      </div>
                    </Col>
                    <Col className="col-md-auto d-none d-md-block">Page <strong> {pageIndex + 1} of {pageOptions.length} </strong>
                    </Col>
                    <Col className="col-md-auto">
                      <Input type="number" min={1} style={{ width: 70 }} max={pageOptions.length} defaultValue={pageIndex + 1} onChange={onChangeInInput} />
                    </Col>
                    <Col className="col-md-auto">
                      <div className="d-flex gap-1">
                        <Button color="light" onClick={nextPage} disabled={!canNextPage}>{">"}</Button>
                      </div>
                    </Col>
                  </Row>
                </div>
                <Modal id="showModal" isOpen={modal} centered size="md">
                  <ModalHeader className="bg-light p-3" toggle={toggle}>
                    {!!isEdit ? "Edit Assessment" : "Add Assessment"}
                  </ModalHeader>
                  <Form onSubmit={(e) => {
                    e.preventDefault();
                    validation.handleSubmit();
                    return false;
                  }}>
                    <ModalBody>
                      <div className="row">
                        <div className="mb-3 col-lg-12">
                          <Label htmlFor="employee" className="form-label">Employee {employeeLoading ? (<Spinner color="primary" size="sm"> Loading... </Spinner>) : ""} </Label>
                          <Select name="employee"
                            value={validation.values.employee}
                            isDisabled={!isApprover}
                            placeholder="Enter Employee"
                            onChange={(e) => { validation.setFieldValue("employee", e); }}
                            options={employeeList}
                            noOptionsMessage={(e) => "Type Employee to get option"}
                            invalid={validation.touched.employee && validation.errors.employee ? true : false}></Select>
                          {validation.touched.employee && validation.errors.employee ? (
                            <small className="text-danger" type="invalid">{validation.errors.employee}</small>
                          ) : null}
                        </div>
                        <div className="mb-3 col-lg-12">
                          <Label htmlFor="assessmentat-field" className="form-label">Assessment Period</Label>
                          <Flatpickr name="assessmentat" className="form-control" id="assessmentat" placeholder="Select Assessment Range Date"
                            options={{
                              mode: "range",
                              dateFormat: "Y/m/d"
                            }}
                            onChange={(obj, str) => { validation.setFieldValue("assessmentat", str) }} />
                          {validation.touched.assessmentat && validation.errors.assessmentat ? (
                            <small className="text-danger" type="invalid">{validation.errors.assessmentat}</small>
                          ) : null}
                        </div>
                      </div>
                    </ModalBody>
                    <div className="modal-footer">
                      <div className="hstack gap-2 justify-content-end">
                        <button
                          type="button"
                          className="btn btn-light"
                          onClick={() => { setModal(false); }}>Tutup</button>
                        <button type="submit" className="btn btn-success">
                          <span className="d-flex align-items-center">
                            <span className="flex-grow-1 me-2">
                              {!!isEdit ? "Update" : "Add Assessment"}
                            </span>
                            {loading && (<Spinner size="sm" className="flex-shrink-0" role="status">Loading...</Spinner>)}
                          </span>
                        </button>
                      </div>
                    </div>
                  </Form>
                </Modal>

              </CardBody>
            </Card>
          </Col>
          <Col xxl={5}>
            <Card>
              <div className="card-body d-flex align-items-center">
                <h5 className="text-uppercase mb-2 flex-grow-1">{info.startat && info.kpiea_employee ? info.kpiea_employee.name + " - " + handleValidDate(info.startat) + " to " + handleValidDate(info.endat) : " - "}</h5>
              </div>
              <div className="card-body" ref={ref}>
                {/* <Grid
                  data={info.kpiea_detail || []}
                  columns={[
                    {
                      name: _(<span className="text-muted">Performance Appraisal Description</span>),
                      id: 'Performance Appraisal Description',
                      width: '58%',
                      data: (row) => row,
                      formatter: (cell) => _(<div>
                        <p className="fw-semibold mb-2 text-success">{cell.perspective}</p>
                        <p className="fw-semibold mb-1">{cell.target}</p>
                        <p className="mb-3">{cell.description}</p>
                        <p className="fw-semibold mb-1">Indicator, Measures and Target</p>
                        <p className="mb-3">{cell.indicator}</p>
                        <div className="hstack gap-2 mt-4 mt-sm-0">
                          <p className="fw-semibold mb-1">Employee:</p>
                          <p className="mb-1">
                            <span className={cell.realization && cell.realization > 0 ? "badge text-uppercase badge-soft-info fw-semibold fs-12 me-1" : "badge text-uppercase badge-soft-warning fw-semibold fs-12 me-1"}>{cell.realization || 0} %</span>
                            <span className={cell.employee_value && cell.employee_value > 0 ? "badge text-uppercase badge-soft-success fw-semibold fs-12" : "badge text-uppercase badge-soft-warning fw-semibold fs-12"}> {cell.employee_value}</span>
                          </p>
                        </div>
                        <p className="mb-3"><em>{cell.realization_description || "-"}</em></p>
                        <div className="hstack gap-2 mt-4 mt-sm-0">
                          <p className="fw-semibold mb-1">Assessor:</p>
                          <p className="mb-1">
                            <span className={cell.assessor_score && cell.assessor_score > 0 ? "badge text-uppercase badge-soft-info fw-semibold fs-12 me-1" : "badge text-uppercase badge-soft-warning fw-semibold fs-12 me-1"}>{cell.assessor_score} %</span>
                            <span className={cell.assessor_value && cell.assessor_value > 0 ? "badge text-uppercase badge-soft-success fw-semibold fs-12" : "badge text-uppercase badge-soft-warning fw-semibold fs-12"}> {cell.assessor_value}</span>
                          </p>
                        </div>
                        <p className="mb-3"><em>{cell.assessor_description || "-"}</em></p>
                      </div>)
                    }]}
                  Search={false}
                  fixedHeader={true}
                  height={'600px'}
                  sort={true} /> */}
              </div>
            </Card>
          </Col>
        </Row>
      </Container>
    </div >
  );
};

export default EmployeeAssessment;
